export interface NicheJobIntent {
  slug: string;
  name: string;
  shortName: string;
  description: string;
  category: "Schedule" | "Location" | "Experience" | "Industry" | "Role";
  iconName: string;
}

export const NICHE_JOB_INTENTS: NicheJobIntent[] = [
  {
    slug: "part-time",
    name: "Part-Time",
    shortName: "Part-Time",
    description: "Flexible part-time hours, weekend shifts, and local employer schedules.",
    category: "Schedule",
    iconName: "Clock"
  },
  {
    slug: "remote",
    name: "Remote & Hybrid",
    shortName: "Remote",
    description: "Distributed, work-from-home, and flexible hybrid role options.",
    category: "Location",
    iconName: "Globe"
  },
  {
    slug: "entry-level",
    name: "Entry-Level",
    shortName: "Entry-Level",
    description: "First jobs, trainee roles, no-experience-needed career entry paths.",
    category: "Experience",
    iconName: "GraduationCap"
  },
  {
    slug: "warehouse",
    name: "Warehouse & Logistics",
    shortName: "Warehouse",
    description: "Fulfillment, material handling, shipping, and supply chain positions.",
    category: "Industry",
    iconName: "Building2"
  },
  {
    slug: "night-shift",
    name: "Night-Shift & Overnight",
    shortName: "Night-Shift",
    description: "Overnight facility, security, logistics, and late-shift roles.",
    category: "Schedule",
    iconName: "Moon"
  },
  {
    slug: "healthcare",
    name: "Healthcare & Medical",
    shortName: "Healthcare",
    description: "Local clinics, medical practices, dental offices, and rehab facilities.",
    category: "Industry",
    iconName: "Activity"
  },
  {
    slug: "trade-services",
    name: "Trade & Construction",
    shortName: "Trades",
    description: "Electrical, plumbing, HVAC, general contracting, and skilled trades.",
    category: "Industry",
    iconName: "Wrench"
  },
  {
    slug: "receptionist",
    name: "Receptionist & Front Desk",
    shortName: "Receptionist",
    description: "Administrative support, office coordination, and client relations.",
    category: "Role",
    iconName: "Users"
  },
  {
    slug: "driver",
    name: "Delivery & Driver",
    shortName: "Driver",
    description: "Local route driving, courier services, and transport logistics.",
    category: "Role",
    iconName: "Compass"
  },
  {
    slug: "hospitality",
    name: "Hospitality & Restaurant",
    shortName: "Hospitality",
    description: "Food service, hotel operations, catering, and guest management.",
    category: "Industry",
    iconName: "Sparkles"
  }
];

export function getAllNicheIntents(): NicheJobIntent[] {
  return NICHE_JOB_INTENTS;
}

export function getNicheIntentBySlug(slug: string): NicheJobIntent | null {
  if (!slug) return null;
  const clean = slug.toLowerCase().trim();
  return NICHE_JOB_INTENTS.find(n => n.slug === clean) || null;
}
